import { ClickableAITag } from 'component/aitag';
import type { CommentConfig } from 'component/comment';
import type { Feature } from 'util/stdtypes';

export const AITagFeature: Feature<CommentConfig, {}> = {
    name: 'AI Tag',
    key: 'aitag',
    dev: true,
    providesConfig: {
        pageTopRightWidgets: [() => <ClickableAITag />],
    },
};
